import React, { ReactNode, useState } from "react";

import { List, ToggleButton } from "@samskip/frontend-components";

interface ExpandableListProps<T> {
  /** The list of elements that need to be displayed. */
  list: T[];
  /** The transforming function that iterates trough the list and returns the wanted react node for each list item.*/
  elementTransform: (listItem: T) => ReactNode;
  /** The max list items to show. If it's greater than the list length, all elements will be shown without the toggle link. */
  max?: number;
  /** The element on the link to display when max(less than the list length) items are shown, indicating that there are more items to be shown. */
  closedText?: ReactNode;
  /** The element on the link to display when all items are shown, indicating that the list can be shortened. */
  expandedText?: ReactNode;
}

const ExpandableList = <T,>({
  list,
  elementTransform,
  max = list.length,
  closedText = "Show less",
  expandedText = "Show more",
}: ExpandableListProps<T>) => {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => {
    setExpanded((oldExpanded) => !oldExpanded);
  };
  return (
    <div>
      <List>
        {list.slice(0, max).map((element) => elementTransform(element))}
        {expanded &&
          list.slice(max).map((element) => elementTransform(element))}
      </List>
      {max < list.length && (
        <ToggleButton
          expandedMessage={expandedText}
          message={closedText}
          onClick={toggle}
          open={expanded}
        />
      )}
    </div>
  );
};

export default ExpandableList;
